import PropTypes from 'prop-types';
import ProfileInfoFactory from '../../user/profile-info/ProfileInfoFactory';
import VisibleIf from '../../components/VisibleIf';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import styles from './project-card-wrapper.module.less';

const Link = ({ project, clickable, actionInformation, children }) => {
    if (clickable) {
        return (
            <TrackEventLink
                category="Project card"
                action={`Click - ${actionInformation}`}
                label={project.id.toString()}
                to={`/project/${project.id}`}
                className={styles.linkBlock}
            >
                {children}
            </TrackEventLink>
        );
    }

    return <div>{children}</div>;
};

Link.propTypes = {
    project: PropTypes.object.isRequired,
    clickable: PropTypes.bool,
    actionInformation: PropTypes.string,
    children: PropTypes.node,
};

Link.defaultProps = {
    clickable: false,
    children: null,
    actionInformation: 'General',
};

const ProjectCardWrapper = (props) => {
    const { project, subproject, clickable, actionInformation, children } = props;

    return (
        <div className={styles.container}>
            <Link clickable={clickable} project={project} actionInformation={actionInformation}>
                <VisibleIf isVisible={!props.hideProjectImage}>
                    <div
                        style={{
                            backgroundImage: project.img_url ? `url(${project.img_url})` : null,
                        }}
                        className={project.img_url ? styles.fullImage : styles.noImage}
                    >
                        {subproject?.img_url && (
                            <div
                                className={styles.subprojectImgBubble}
                                style={{ backgroundImage: `url(${subproject.img_url || subproject.fallback_img_url})` }}
                            />
                        )}
                        <VisibleIf isVisible={!project.img_url}>
                            <p>{project.id}</p>
                        </VisibleIf>
                    </div>
                </VisibleIf>
                <div className={styles.textContainer}>
                    <div>
                        <div className={styles.title}>{subproject?.title || project.title}</div>
                        <div className={styles.profile}>
                            <ProfileInfoFactory
                                project={project}
                                textContainerClassName={styles.profileTextContainer}
                                imageSize={40}
                                disableEdit
                            />
                        </div>
                    </div>
                    {children}
                </div>
            </Link>
        </div>
    );
};

ProjectCardWrapper.defaultProps = {
    clickable: true,
    children: null,
    hideProjectImage: false,
};

ProjectCardWrapper.propTypes = {
    project: PropTypes.object.isRequired,
    subproject: PropTypes.object,
    children: PropTypes.node,
    clickable: PropTypes.bool,
    hideProjectImage: PropTypes.bool,
};

export default ProjectCardWrapper;
